export const COLORS = {
    WHITE: '#ffffff',
    BLACK: '#000000',
    GRAY: '#B0B0B0',
    YELLOW: '#EABF00',
    RED: '#E53016'
}
